import { gql } from '@apollo/client'

export const AskMessageMutation = gql`
    mutation ask($input: AskMessageInput!) {
        ask(input: $input) {
            id
            answer
            promptMessageId
        }
    }
`

export const GiveFeedbackMutation = gql`
    mutation giveFeedback($input: GiveFeedbackInput!) {
        giveFeedback(input: $input) {
            success
        }
    }
`
